import styles from "../../styles/components/error/NotFoundPage.module.css";
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LangContext } from '../../context/LangContext';
import { ThemeContext } from '../../context/ThemeContext';

const translations = {
  ru: {
    title: "404 - Страница не найдена",
    message: "Извините, запрошенная страница не существует или у вас нет к ней доступа.",
    homeLink: "Вернуться на главную"
  },
  en: {
    title: "404 - Page Not Found",
    message: "Sorry, the requested page does not exist or you do not have access to it.",
    homeLink: "Return to Home Page"
  },
};

export const NotFoundPage = () => {
  const { langSelected } = useContext(LangContext);
  const { theme } = useContext(ThemeContext);
  const t = translations[langSelected] || translations.ru;

  const isDark = theme === 'dark';

  return (
    <div className={`${styles.notFoundContainer} ${isDark ? styles.darkContainer : ''}`}>
      <h1 className={`${styles.title} ${isDark ? styles.darkTitle : ''}`}>{t.title}</h1>
      <p className={`${styles.message} ${isDark ? styles.darkMessage : ''}`}>
        {t.message}
      </p>
      <Link to="/" className={styles.homeLink}>
        {t.homeLink}
      </Link>
    </div>
  );
};